module.exports = __webpack_public_path__ + "img/internet-box-00.2f61646c.png";